import { Dialog, DialogContent, IconButton } from '@mui/material';
import { IDetectedBarcode, Scanner } from '@yudiel/react-qr-scanner';
import { XClose } from 'untitledui-js-base';

interface AccidentScanQrDialogProps {
  onScan: (data: IDetectedBarcode[]) => void;
  open: boolean;
  onClose: () => void;
}

export const AccidentScanQrDialog = ({ open, onScan, onClose }: AccidentScanQrDialogProps) => (
  <Dialog open={open}>
    <IconButton
      aria-label="close"
      onClick={onClose}
      sx={(theme) => ({
        position: 'absolute',
        right: 8,
        top: 8,
        color: theme.palette.grey[500],
        zIndex: 999
      })}
    >
      <XClose />
    </IconButton>
    <DialogContent sx={{ paddingTop: 6 }}>
      <Scanner
        onScan={onScan}
        components={{
          audio: false,
          torch: true,
          zoom: true,
          finder: true
        }}
      />
    </DialogContent>
  </Dialog>
);
